import { render } from "./MessageTranslateDialog.vue?vue&type=template&id=0dd4923e&scoped=true"
import script from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
export * from "./MessageTranslateDialog.vue?vue&type=script&lang=js"

import "./MessageTranslateDialog.vue?vue&type=style&index=0&id=0dd4923e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd4923e"]])

export default __exports__